// assets
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import SafetyOutlined from '@ant-design/icons/SafetyOutlined';
import SafetyCertificateOutlined from '@ant-design/icons/SafetyCertificateOutlined';
import AppstoreOutlined from '@ant-design/icons/AppstoreOutlined';
import SettingOutlined from '@ant-design/icons/SettingOutlined';
import UserOutlined from '@ant-design/icons/UserOutlined';
import BankOutlined from '@ant-design/icons/BankOutlined';
import ProjectOutlined from '@ant-design/icons/ProjectOutlined';
import FolderOpenOutlined from '@ant-design/icons/FolderOpenOutlined';
import FileTextOutlined from '@ant-design/icons/FileTextOutlined';
import FileOutlined from '@ant-design/icons/FileOutlined';
import AudioOutlined from '@ant-design/icons/AudioOutlined';
import MessageOutlined from '@ant-design/icons/MessageOutlined';
import CheckSquareOutlined from '@ant-design/icons/CheckSquareOutlined';
import VideoCameraOutlined from '@ant-design/icons/VideoCameraOutlined';
import AIIcon from 'components/icons/AIIcon';
import CrownIcon from 'components/icons/CrownIcon';
import VoiceIcon from 'components/icons/VoiceIcon';

// type
import { NavItemType } from 'types/menu';

// icons
const icons = {
  TeamOutlined,
  SafetyOutlined,
  SafetyCertificateOutlined,
  AppstoreOutlined,
  SettingOutlined,
  UserOutlined,
  BankOutlined,
  ProjectOutlined,
  FolderOpenOutlined,
  FileTextOutlined,
  FileOutlined,
  AudioOutlined,
  MessageOutlined,
  CheckSquareOutlined,
  VideoCameraOutlined,
  AIIcon,
  CrownIcon,
  VoiceIcon
};

// ==============================|| MENU ITEMS - PAGES ||============================== //

const pages: NavItemType = {
  id: 'group-pages',
  title: 'pages',
  type: 'group',
  children: [
    // 👇 Menu "Chat"
    {
      id: 'chat',
      title: 'chat',
      type: 'item',
      icon: icons.AIIcon,
      url: '/ai-chat',
      rule: 'ai_chat.read'
    },
    // 👇 Menu "Vídeos IA"
    {
      id: 'ai-video',
      title: 'ai-video',
      type: 'item',
      icon: icons.VideoCameraOutlined,
      url: '/ai-video',
      rule: 'ai_video.read'
    },
    // 👇 Menu "Administração"
    {
      id: 'administration',
      title: 'administration',
      type: 'collapse',
      icon: icons.SettingOutlined,
      children: [
        {
          id: 'company',
          title: 'company',
          type: 'item',
          icon: icons.BankOutlined,
          url: '/company',
          rule: 'company.read'
        },
        {
          id: 'departments',
          title: 'departments',
          type: 'item',
          icon: icons.AppstoreOutlined,
          url: '/departments',
          rule: 'departments.read'
        },
        {
          id: 'roles',
          title: 'roles',
          type: 'item',
          icon: icons.SafetyOutlined,
          url: '/roles',
          rule: 'roles.read'
        },
        {
          id: 'collaborators',
          title: 'users',
          type: 'item',
          icon: icons.TeamOutlined,
          url: '/users',
          rule: 'users.read'
        },
        {
          id: 'clients',
          title: 'customer',
          type: 'item',
          icon: icons.UserOutlined,
          url: '/clients',
          rule: 'customers.read'
        },
        {
          id: 'ai-usage',
          title: 'ai-usage',
          type: 'item',
          icon: icons.AIIcon,
          url: '/ai-usage',
          rule: 'ai.usage.read'
        },
        // ========== Créditos (regras: credits.rules.read | credits.rules.manage | credits.packages.read | credits.packages.manage) ==========
      ]
    },
    // 👇 Menu "Gestão de Projetos"
    {
      id: 'software-management',
      title: 'software-management',
      type: 'collapse',
      icon: icons.ProjectOutlined,
      children: [
        {
          id: 'projects',
          title: 'projects',
          type: 'item',
          icon: icons.FolderOpenOutlined,
          url: '/projects',
          rule: 'projects.read'
        },
        {
          id: 'scopes',
          title: 'scopes',
          type: 'item',
          icon: icons.FolderOpenOutlined,
          url: '/scopes',
          rule: 'projects-management.scopes.read'
        }
      ]
    },
    // 👇 Menu "Jurídico"
    {
      id: 'legal',
      title: 'legal',
      type: 'collapse',
      icon: icons.FileTextOutlined,
      children: [
        // 👇 Submenu "Contrato"
        {
          id: 'legal-contract',
          title: 'contract',
          type: 'collapse',
          icon: icons.FileTextOutlined,
          children: [
            {
              id: 'contract-templates',
              title: 'contract-templates',
              type: 'item',
              icon: icons.FileOutlined,
              url: '/contracts/templates',
              rule: 'projects-management.contracts.templates.read'
            },
            {
              id: 'contracts-list',
              title: 'contracts',
              type: 'item',
              icon: icons.FileTextOutlined,
              url: '/contracts',
              rule: 'projects-management.contracts.read'
            }
          ]
        }
      ]
    },
    // 👇 Cofre de Chaves & Logins
    {
      id: 'security-keys',
      title: 'security-keys',
      type: 'item',
      icon: icons.SafetyCertificateOutlined,
      url: '/security-keys',
      rule: 'security-keys.read'
    },
    // 👇 Menu "Transcrições" (link direto para /transcriptions; sem permissão mostra ícone premium)
    {
      id: 'transcriptions',
      title: 'transcriptions',
      type: 'item',
      icon: icons.VoiceIcon,
      premiumIcon: icons.CrownIcon,
      url: '/transcriptions',
      rule: 'transcriptions.read',
      permissionDisabled: true
    },
    // 👇 Menu "WhatsApp" (link direto para conversas; demais telas vivem no header da inbox)
    {
      id: 'whatsapp',
      title: 'WhatsApp',
      type: 'item',
      icon: icons.MessageOutlined,
      url: '/whatsapp/inbox',
      rule: 'whatsapp.instances.read'
    },
    // 👇 Tarefas
    {
      id: 'tasks',
      title: 'tasks',
      type: 'item',
      icon: icons.CheckSquareOutlined,
      url: '/tasks',
      rule: 'tasks.read'
    }
  ]
};

export default pages;
